/** imported components

  * BreadcrumbsItem for ===> dynamic breadcrumb component of react.
  * ManufacturingCostPagePlantView  ===> custom view component.
  * useHistory ===> hook to access the history object.
  * useState, useEffect ===> React hooks (useState is a way to get/set value)
  * serviceProvider for ===> working with api

**/

import React from "react";
import serviceProvider from '../../services/axios'
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { useEffect, useState } from 'react';
import { useHistory, Link, Redirect } from "react-router-dom";
import { ManufacturingCostPagePlantView } from "./manufacturing-cost-page-plant-view";
//ManufacturingCostPagePlantController starts
export const ManufacturingCostPagePlantController = (props) => {
  //defining varibales here
  const segments = window.location.pathname.slice(1).split("/");
  const [unlockbutton, setUnlockbutton] = useState(false);
  const slug = segments[2];
  const sid = segments[3];
  const ssid=segments[4];
  const [results, setResults] = useState([]);
  const [refadd, setRefadd] = useState(false);
  const user = JSON.parse(localStorage.getItem("userData"));
  const usid = user ? user.uid : 0;
 
  useEffect(() => {
		const search = async () => {
			const apiUrl = `/businesscaseplantloss?param=questionaire&slug=${slug}&uid=${usid}&sid=${sid}&ssid=${ssid}`;
			const { data } = await serviceProvider.get(apiUrl,true, {});
			setResults(data);
      // setRefadd(false);
		};
		search();
	}, [unlockbutton]);
  

	if (results.length) {
		if(results[0].block == 1){
			var pp = "/not-found";
			return <Redirect to="/404" />;
			return (
					<>
						<div></div>
					</>
			);
		}
		if(window.location.hash != '' && (results[0].isLocks == 1 || results[0].has_businesscase == 1)){
			var pp = "/not-found";
			return <Redirect to="/not-found" />;
			return (
				<>
					<div></div>
				</>
			);
		}
		else{
			return <ManufacturingCostPagePlantView setRefadd={setRefadd}  slug={slug} quesResult={results} unlockbutton={unlockbutton} setUnlockbutton={setUnlockbutton} {...props} />;
		}	
	}
	else{
		return (
			<>
				<div></div>
			</>
		);
		
	}

} 




